import {CSSProperties, FC} from 'react';


export interface IIconCarryingBmwProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconCarryingBmw: FC<IIconCarryingBmwProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path d="M18.064 7.966H14.47v-1.59A2.473 2.473 0 0 0 12 3.906a2.473 2.473 0 0 0-2.47 2.47v1.59H5.935L3 20.094h18L18.064 7.966Zm-7.48-1.59c0-.78.635-1.415 1.416-1.415.78 0 1.416.635 1.416 1.415v1.59h-2.832v-1.59Zm.385 10.028-.994-1.505-.335.383v1.122H8.603v-3.775H9.64v1.542l1.254-1.542h1.063l-1.371 1.69 1.467 2.085H10.97Zm2.998.026c-1.127 0-1.909-.935-1.909-1.946 0-.957.697-1.882 1.872-1.882.648 0 1.164.272 1.446.771l-.824.644c-.032-.075-.218-.495-.686-.495-.516 0-.755.5-.755.989 0 .441.191 1 .75 1 .292 0 .547-.155.643-.32h-.59v-.903h1.712v.473c0 .914-.649 1.67-1.659 1.67Z" />
        </svg>
    );
};
